import {IEndPoint} from "/@lib@/commons/io/io.js";

//Cache des xslt ancré sur le fichier wed (tpl.ownerDocument) car la même xsl
// peut-etre appelée de multiples fois dans le wed.
export function getXsltProcessor(resolver: IEndPoint, tpl: Element): Promise<XSLTProcessor> {
	const src = resolver.resolve(tpl.getAttribute("xslUrl"));
	let xsltCache = (tpl.ownerDocument as any).xsltCache as Map<string, Promise<XSLTProcessor>>;
	let xslt: Promise<XSLTProcessor>;
	if (!xsltCache) xsltCache = (tpl.ownerDocument as any).xsltCache = new Map<string, Promise<XSLTProcessor>>();
	else xslt = xsltCache.get(src.url);
	if (!xslt) {
		xslt = resolver.resolve(tpl.getAttribute("xslUrl")).fetchDom().then((dom) => {
			const x = new XSLTProcessor();
			x.importStylesheet(dom);
			return x;
		});
		xsltCache.set(src.url, xslt);
	}
	return xslt;
}